module.exports = __webpack_public_path__ + "static/media/seeker.dfb831a0.svg";